import React , {useEffect, useRef, useState} from 'react'
import DataTable,  { createTheme  } from 'react-data-table-component';
import Axios from 'axios';
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Modals from './Modals';
import Modals_Load from './Modals_Load';
import { useHistory } from "react-router-dom";

import ReactToPrint from "react-to-print";
import "./istyles.css";
import JsBarcode from 'jsbarcode'; 
import { QRCodeSVG } from 'qrcode.react'; 

import { format, parseISO, isAfter } from 'date-fns';


const FullInvoice = React.forwardRef(({invoice}, ref) => { 
    const {gclang,setgclang} = useContext(AuthContext);
    // const logoSrc = gclang === "th" ? "logo_cubest_th.jpg" : "logo_cubest_en.jpg";
    const logoSrc = gclang === "th" ? "New_CU-Logo2.jpg" : "New_CU-Logo2.jpg";

  return (
    <div ref={ref} style={{ marginLeft: '20px' }}>   
    <br></br>
 
    
    <table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "3" style={{"WIDTH": "197px"}}><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
                <tr>
                
                  <td align="center"><strong>ผลสอบวิชาความถนัดทางธุรกิจ 
                              (CU-BEST)</strong></td>
                </tr>
               

                <tr>
											<td align="center"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong>
											</td>
										</tr>

                <tr>
											<td align="center"><strong>ครั้งที่:&nbsp;</strong>
												<span>{invoice.CUBEST}</span></td>
								</tr>
								              
                <td align="right">
                <QRCodeSVG       
                        value={`http://cubest.cbs.chula.ac.th/qcheck_hisScore?lang=${invoice.Test_language.toLowerCase()}&ID_Number=${invoice.ID_Number}&CUBEST=${invoice.CUBEST}`} // The text or URL for the QR code
                        size={80} // The size of the QR code
                        bgColor="#ffffff" // Background color
                        fgColor="#000000" // Foreground color
                        level="H" // Error correction level ('L', 'M', 'Q', 'H')
                        includeMargin={true} // Adds a margin around the QR code
                />  
                  
                </td>              
              </tr>


    </table>

<table style={{"WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
							<td align="left">หลักสูตรบริหารธุรกิจมหาบัณฑิต</td>
						</tr>
            <tr>
              <td align="left">คณะพาณิชยศาสตร์และการบัญชี, จุฬาฯ</td>
            </tr>                      
            <tr>
              <td align="left">
                ห้อง 506, อาคารอนุสรณ์ 50 ปี
              </td>
            </tr>
            <tr>
              <td align="left">ถนนพญาไท กรุงเทพฯ 10330</td>
          </tr>           
            <tr>
              <td align="left">โทร. 0-22185717-9
              </td>
            </tr>          
            <tr>
              <td align="left">Website: <a href="https://mba.cbs.chula.ac.th/">https://mba.cbs.chula.ac.th/</a></td>
            </tr>

            </table>

<table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}>ชื่อ:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.fullname}</span></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}>วันที่สอบ:&nbsp;</td>
								<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>{invoice.test_date2}</span></font></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}>วันหมดอายุ:&nbsp;</td>
								<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>{invoice.expiry_date2}</span></font></td>
						</tr>

            <tr>
                <td align="right" style={{"width": "129px"}}>เลขที่นั่งสอบ:&nbsp;</td>
                <td align="left"><span style={{"width":"320px"}}><b>{invoice.testid}</b></span></td>
            </tr>                   
  </table>
                
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}
  <br></br>

<table cellspacing="1" cellpadding="1" width="648px" align="left" border="1">
	<tr>
		<td align="center">&nbsp;</td>
		<td align="center"><b>วิเคราะห์ธุรกิจ(250)</b></td>
		<td align="center"><b>คณิตศาสตร์(250)</b></td>
		<td align="center"><b>รวม(500)</b></td>
	</tr>

	<tr>
		<td align="center"><b>คะแนนที่ได้</b></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkSection1}</span></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkSection2}</span></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkPoint}</span></td>
	</tr>
</table>

    {/* Watermark 1234567890121*/}
    <div
        style={{
          position: "absolute",
          top: "25%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          opacity: 0.2, // Adjust transparency
          zIndex: 0,
          pointerEvents: "none", // Prevent user interaction
        }}
      >
        <img
          src={logoSrc} // Change to your image path
          alt="Watermark"
          style={{
            width: "400px", // Adjust size
            height: "auto",
          }}
        />
    </div>
   

    
    {/* <QRCodeSVG       
            value={`http://localhost:3001/qcheck_hisScore?lang=${invoice.Test_language}&ID_Number=${invoice.ID_Number}&CUBEST=${invoice.CUBEST}`} // The text or URL for the QR code
            size={150} // The size of the QR code
            bgColor="#ffffff" // Background color
            fgColor="#000000" // Foreground color
            level="H" // Error correction level ('L', 'M', 'Q', 'H')
            includeMargin={true} // Adds a margin around the QR code
    /> */}
    </div>
 
  );
});


const FrmHisScore_th = () => {
  const fullInvoiceRefs = useRef([]);
      
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);
  const history = useHistory();
  
  const {token,settoken} = useContext(AuthContext);

  const [q, setq] = useState("");
  
  const [data,setdata] = useState([]);
    
  const [searchcolumns,setsearchcolumns] = useState(["CUBEST","test_language"]);
    
  const [isedit,setisedit] = useState("0");
  const [pending, setPending] = useState(true);
  const {gclang} = useContext(AuthContext);
  const {gnuserid} = useContext(AuthContext);


  const [Qlang,setQlang] = useState({        
    lang:gclang,
    ID_Number:gnuserid    
  });


  useEffect(() => {
   
    async function fetchData() { 
      
      const response3 = await Axios.post('/qhisscore',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
            
      let output3 = response3.data; 
      console.log('tid3',output3);
      
      setPending(false);                  
      setdata(output3);
                                   
      fullInvoiceRefs.current = output3.map((_, i) => fullInvoiceRefs.current[i] || React.createRef());
            
    }
       
    fetchData();  // show data    
         
    },[token]);

  

    const columns = [
      {
        name: 'ครั้งที่',
        selector: row => row.CUBEST,
        sortable: true,
        
      },
      {
          name: 'สถานะ',
          selector: row => row.ExpirationStatus,
          sortable: true,
          
      },
      {
        name: 'วันที่คะแนนหมด',
        selector: row => row.expiry_date,
        sortable: true,
        
      },
      {
      name: 'คะแนนวิเคราะห์',
      selector: row => row.MarkSection1,
      sortable: true,
      
      },
      {
        name: 'คะแนนคณิตศาสตร์',
        selector: row => row.MarkSection2,
        sortable: true,
        
      },

      {
        name: 'คะแนนผลรวม',
        selector: row => row.MarkPoint,
        sortable: true,        
      },
       
         {
           name: "Actions",
           cell: (row, index) => {                
             return (            
               <span>
                 &nbsp;&nbsp;
                 <ReactToPrint
                   trigger={() => (
                      <button disabled={row.ExpirationStatus === 'Expired'}>พิมพ์คะแนน</button>
                    //  <button>พิมพ์คะแนน</button>
                   )}
                   content={() => fullInvoiceRefs.current[index].current}
                 />&nbsp;&nbsp;
                                                  
                 {/* Hidden Component for Printing */}
                 <div style={{ display: 'none' }}>
                   <FullInvoice ref={fullInvoiceRefs.current[index]} invoice={row} />
                 </div>                
               </span>
             );
           },
           ignoreRowClick: true,
           allowOverflow: true,
           button: true,
         }
     
     
     
  ];

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'uppercase',        
        color: '#202124',        
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    pagination: {
      style: {
        border: 'none',
      },
    },
  };


function search(rows){
    
  return rows.filter( (row) =>             
    // ค้นหา แบบ ทุก columns
    //columns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)      
    // ค้นหา แบบ กำหนดว่าจะเอา Column ไหนบ้าง
    searchcolumns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)    
  
  );
}



  return (
    <>
      <br></br>      
        <div className="card" style={{width: '100%;'}}>      
        <div className="card-body">
        
          <div className="row mb-3">  
            <h4><i class="fa fa-table" aria-hidden="true"></i>&nbsp;ประวัติการสมัครและผลคะแนน</h4>
          </div>

                  
          <div class="row">  
            <div class="col-sm-12 my-1">
                <div class="card">
                    <div class="card-body">                                               

                    <DataTable
                            // title="Patient Lists"
                            columns={columns}
                            //data={data}            
                            data={search(data)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.id);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>       
  

    </div>
    </div>
    </>      
  )
}

export default FrmHisScore_th